import {
  GET_CENTERS,
  UPDATE_CENTERS,
  GET_CENTERS_WITH_ID,
  CREATE_CENTERS,
  GET_USERS_BY_CENTERS_ID,
  GET_USERS_BE_ADMIN_CENTER,
  UPDATE_CENTER_ADMIN,
  GET_ALL_CENTERS_REPORT,
  GET_ALL_SUPERVISORS,
  UPDATE_CENTER_STATUS,
  GET_CENTERS_ACTIVE_COUNT,
  GET_CENTERS_DEACTIVE_COUNT,
  GET_CENTERS_STATISTICS,
  GET_CENTERS_STATISTICS_WITH_ID,
} from './constants';
import {PayloadUpdate, PayloadCreate} from './interfaces';

export function getCentersAction(payload: Object) {
  return {
    type: GET_CENTERS,
    payload,
  };
}

export function getCentersWithIdAction(payload: {id: number}) {
  return {
    type: GET_CENTERS_WITH_ID,
    payload,
  };
}

export function updateCenterActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_CENTERS,
    payload,
  };
}

export function createCentersActions(payload: PayloadCreate) {
  return {
    type: CREATE_CENTERS,
    payload,
  };
}

export function getUsersByCenterIdAction(payload: Object) {
  return {
    type: GET_USERS_BY_CENTERS_ID,
    payload,
  };
}

export function getUsersBeAdminCenterAction(payload: Object) {
  return {
    type: GET_USERS_BE_ADMIN_CENTER,
    payload,
  };
}

export function updateCenterAdminActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_CENTER_ADMIN,
    payload,
  };
}

export function getAllCentersReportAction(payload: Object) {
  return {
    type: GET_ALL_CENTERS_REPORT,
    payload,
  };
}

export function getSupervisorsAction(payload: Object) {
  return {
    type: GET_ALL_SUPERVISORS,
    payload,
  };
}

export function updateCenterStatusActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_CENTER_STATUS,
    payload,
  };
}

export function getCentersActiveCountActions(payload: Object) {
  return {
    type: GET_CENTERS_ACTIVE_COUNT,
    payload,
  };
}

export function getCentersDeactiveCountActions(payload: Object) {
  return {
    type: GET_CENTERS_DEACTIVE_COUNT,
    payload,
  };
}

export function getCenterStatisticsAction(payload: Object) {
  return {
    type: GET_CENTERS_STATISTICS,
    payload,
  };
}

export function getCenterStatisticsWithIdAction(payload: {id: number}) {
  return {
    type: GET_CENTERS_STATISTICS_WITH_ID,
    payload,
  };
}
